import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AdminCableDispatch } from '../../actions';
import CableApp from '../../cable';
import { AUTH_TOKEN_KEY } from '../../constants/base';

const mapStateToProps = state => ({ currentProject: state.currentProject });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ AdminCableDispatch }, dispatch);
};


class AdminCable extends Component {
  
  componentWillReceiveProps (nextProps) {
    
  }
  
  componentWillMount () {
    this.subscribe();
  }
  
  componentWillUnmount () {
    this.unsubscribe();
  }
  
  unsubscribe () {
    if (typeof CableApp !== 'undefined' && CableApp.linkUpdates ){
      CableApp.linkUpdates.unsubscribe()
    }
  }
  
  subscribe () {
    const { AdminCableDispatch } = this.props;
    const accessJWT = localStorage.getItem(AUTH_TOKEN_KEY);
  
    CableApp.linkUpdates = CableApp.cable.subscriptions.create({ channel: 'AdminChannel', token: accessJWT }, {
      disconnected: () => {},
      received: (data) => {
        // console.log(data)
        if (data.type !== 'undefined' && data.payload !== 'undefined')
          AdminCableDispatch({...data, fromCable: true});
      }
    });
  }
  
  render() {
    return null
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(AdminCable);


// WEBPACK FOOTER //
// ./src/components/helpers/AdminCable.js